
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ErrorResponse } from '@gtpl/shared-models/common-models';

export function errorHandler<T extends GlobalResponseObject>(classType: { new(): T }, errorObj: ErrorResponse): T {
    let intlCode;
    let message;
    if (errorObj.intlCode) {
        intlCode = errorObj.intlCode;
        message = errorObj.message;
    } else {
        intlCode = 0;
        message = errorObj.message;
    }
    const responseObj = new classType();
    responseObj.status = false;
    responseObj.intlCode = intlCode;
    responseObj.internalMessage = message;

    return responseObj;
}
